(function ($) {
    'use strict';

    /**
     * Check for Internet Explorer
     * @returns {boolean}
     */
    function isIe() {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf('MSIE ');

        return msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./);
    }

    /**
     * Check for Windows
     * @returns {boolean}
     */
    function isWin() {
        return navigator.platform.indexOf('Win') > -1;
    }

    if (isIe()) {
        $('body').addClass('IE');
    }

    if (isWin()) {
        $('body').addClass('WIN');
    }
})(jQuery);
